import { useState } from "react";

const GoFaster = ({ GoFasterInfo }) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className="bg-[#292929] lg:pb-[142px] md:pb-[100px] sm:pb-[80px] pb-[40px]">
      <div className="custom-container py-[30px] sm:py-[50px]">
        <div className="font-[Rockwell] 2xl:text-[45px] xl:text-[40px] lg:text-[35px] md:text-[30px] sm:text-[25px] text-[18px] font-extrabold border-b-[2px] sm:border-b-[3px] border-[#ffff] text-[#7ABF5B]">
          {GoFasterInfo?.title}
        </div>

        <div className="flex flex-wrap">
          {GoFasterInfo?.list?.map((items, index) => {
            return (
              <div
                onClick={() => setActiveTab(index)}
                className={`${activeTab == index ? "text-[#7ABF5B]" : "text-[#fff]"
                  } cursor-pointer lg:mr-[60px] md:mr-[40px] mr-[10px] font-[Roboto] 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#000] lg:mt-[40px] mt-[20px] font-bold`}
              >
                <span
                  className={`${activeTab == index
                    ? "underline  lg:decoration-[5px] sm:decoration-[4px] decoration-[2px] lg:underline-offset-[24px] md:underline-offset-[18px] sm:underline-offset-[15px] underline-offset-[8px] decoration-[#7ABF5B] pb-[16px]"
                    : ""
                    }`}
                >
                  {items}
                </span>
              </div>
            );
          })}
        </div>

        <div className="font-[Roboto] font-normal 2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px] text-[#fff] mt-[45px]">
          {GoFasterInfo?.info?.map((content, index) => (
            <div
              key={index}
              className={activeTab === index ? "block" : "hidden"}
            >
              {content}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default GoFaster;
